import { gql } from '@apollo/client';

export const GET_ROLE_CLAIMS = gql`
  query GetRoleClaims($userId: ID!) {
    getRoleClaims(userId: $userId) {
      userId
      compressedRoles
      roleCount
    }
  }
`;
